/**
 * settings.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, FormArray } from "@angular/forms";
import { MapSetting, Setting } from "./setting";
import { SettingService } from "./setting.service";
import { ArraySegmentsPipe } from "app/support/pipes/array-segments.pipe";
import { anyChildHasError } from "app/support/validators";
import { TypedDataHolder } from "app/common/data/typed-data";

@Component({
  template: `
    <div class="container">
      <div class="well center-block">
        <h2>Settings</h2>
        <p>
          These settings only affect this computer. Their values will be saved
          immediately after you change them, however <em>some of them may
          require you to reload or restart the application to take effect</em>.
        </p>
        <div class="row">
          <div
            *ngFor="let setting of settings"
            class="col-sm-12 form-group">
            <label class="capitalized">
              <span *ngIf="setting.keyType" class="glyphicon glyphicon-list"></span>
              {{setting.name}}
            </label>
            <span *ngIf="setting.debugOnly" class="text-info">
              (debug only)
            </span>
            <!-- regular settings -->
            <typed-control *ngIf="!setting.keyType" [input]="setting"></typed-control>
            <!-- map settings -->
            <div *ngIf="setting.keyType">
              <p [innerHtml]="setting.presentationUnsafe || setting.presentation"></p>
              <table>
                <tbody>
                <tr *ngFor="let pair of setting.value; let i = index">
                  <td width="30%">
                    <typed-field
                      [input]="keyInputFor(setting)"
                      [control]="setting.control.controls[i].controls[0]"
                      [clearButton]="false"
                      [iconTray]="false"
                      [validationTray]="false"
                      (change)="propagateMapChangeToSettings(setting)">
                    </typed-field>
                  </td>
                  <td width="65%">
                    <typed-field
                      [input]="setting"
                      [control]="setting.control.controls[i].controls[1]"
                      [clearButton]="false"
                      [iconTray]="false"
                      [validationTray]="false"
                      (change)="propagateMapChangeToSettings(setting)">
                    </typed-field>
                  </td>
                  <td width="5%" style="text-align: center">
                    <span
                      class="glyphicon glyphicon-remove text-danger"
                      title="Remove this entry"
                      (click)="shrink(setting, i)">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button class="btn btn-primary form-control" (click)="extend(setting)">
                      Add Entry
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    ".well.center-block {max-width: 600px;}",
    ".well h2 {margin-top: 0;}"
  ]
})
export class SettingsComponent implements OnInit, OnDestroy
{
  public settings : Setting[] = [];

  public form : FormGroup = new FormGroup({});

  constructor (protected settingService : SettingService)
  {
    // Nothing
  }

  public keyInputFor (s : MapSetting) : TypedDataHolder
  {
    return {
      type: s.keyType,
      hints: s.keyHints,
      value: null
    };
  }

  public extend (s : MapSetting) : void
  {
    (s.control as FormArray).push(new FormArray([
      new FormControl(), new FormControl()
    ]));
    this.propagateMapChangeToSettings(s);
  }
  public shrink (s : MapSetting, i : number) : void
  {
    if ((s.control as FormArray).length > i)
    {
      (s.control as FormArray).removeAt(i);
    }
    this.propagateMapChangeToSettings(s);
  }

  private propagateMapChangeToSettings (s : MapSetting) : void
  {
    console.warn("propagating: " + s.name);
    this.settingService.set(s.name, s.control.value);
  }

  public ngOnInit () : void
  {
    this.settings = this.settingService.visible();
    this.settings.forEach((setting : Setting) => {
      if (this.settingService.isMapSetting(setting))
      {
        let controls : FormArray[] = [];
        if (Array.isArray(setting.value))
        {
          setting.value.forEach(([key, value] : [any, any]) => {
            controls.push(new FormArray([
              new FormControl(key),
              new FormControl(value)
            ]));
          });
        }
        setting.control = new FormArray(controls);
        console.warn(setting.control);
        /* setting.control.valueChanges.debounceTime(1000).subscribe(
          (change) => this.settingService.set(setting.name, change)); */
      }
      else
      {
        setting.control = new FormControl(setting.value);
        setting.control.valueChanges.subscribe(
          (change) => this.settingService.set(setting.name, change));
        if (setting.disabled)
        {
          setting.control.disable();
        }
      }
      this.form.addControl(setting.name, setting.control);
    });
  }

  public ngOnDestroy () : void
  {
    // this.changeSubs.unsubscribe();
    this.settings.forEach((setting : Setting) => delete setting.control);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/configuration/settings.component.ts